// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Collection":"_1gQKv6","filterLoading":"_29BI5_","containsSuperHero":"_3WQsXf","fadeInFrames":"_3vNTK9"};